<template>
  <div>
    <div class="wrapper">
      <el-button class="item" size="mini" @click="baseDraw('point')" type="primary">点</el-button>
      <el-button class="item" size="mini" @click="baseDraw('line')" type="primary">线</el-button>
      <el-button class="item" size="mini" @click="baseDraw('polygon')" type="primary">面</el-button>
      <el-button class="item" size="mini" @click="baseDraw('circle')" type="primary">圆</el-button>
      <el-button class="item" size="mini" @click="baseDraw('rectangle')" type="primary">矩形</el-button>
      <el-button class="item" size="mini" @click="baseDraw('StraightArrow')" type="primary">直线箭头</el-button>
      <el-button class="item" size="mini" @click="baseDraw('AttackArrow')" type="primary">攻击箭头</el-button>
      <el-button class="item" size="mini" @click="baseDraw('PincerArrow')" type="primary">钳击箭头</el-button>
      <el-button class="item" size="mini" @click="baseDraw('billboard')" type="primary">图标</el-button>
      <el-button class="item" size="mini" @click="baseDraw('sector')" type="primary">扇形</el-button>
      <el-button class="item" size="mini" @click="baseDraw('sphere')" type="primary">球体</el-button>
      <el-button class="item" size="mini" @click="baseDraw('cone')" type="primary">圆锥</el-button>

    </div>

    <div>3D标绘</div>
    <div class="wrapper">
      <el-button class="item" size="mini" @click="baseDraw('polyline3')" type="primary">线</el-button>
      <el-button class="item" size="mini" @click="baseDraw('polygon3')" type="primary">面</el-button>
      <el-button class="item" size="mini" @click="baseDraw('rectangleP3')" type="primary">矩形面</el-button>
      <el-button class="item" size="mini" @click="baseDraw('rectangle3')" type="primary">矩形</el-button>
      <el-button class="item" size="mini" @click="baseDraw('triangle')" type="primary">三角形</el-button>
      <el-button class="item" size="mini" @click="baseDraw('bezier')" type="primary">曲线</el-button>
      <el-button class="item" size="mini" @click="baseDraw('ellipse3')" type="primary">圆</el-button>
      <el-button class="item" size="mini" @click="baseDraw('straightArrow3')" type="primary">直线箭头</el-button>
      <el-button class="item" size="mini" @click="baseDraw('attackArrow3')" type="primary">攻击箭头</el-button>
      <el-button class="item" size="mini" @click="baseDraw('pincerArrow3')" type="primary">钳击箭头</el-button>
      <el-button class="item" size="mini" @click="baseDraw('ellipsoid3')" type="primary">球体</el-button>
      <el-button class="item" size="mini" @click="baseDraw('cone3')" type="primary">圆锥</el-button>
      <el-button class="item" size="mini" @click="baseDraw('gatheringPlace')" type="primary">集结地</el-button>
      <el-button class="item" size="mini" @click="baseDraw('squadCombat')" type="primary">分队战斗</el-button>
      <el-button class="item" size="mini" @click="baseDraw('wall3')" type="primary">墙体</el-button>
      <el-button class="item" size="mini" @click="baseDraw('polylineVolume3')" type="primary">管道</el-button>
      <el-button class="item" size="mini" @click="baseDraw('assaultDirection3')" type="primary">突击方向</el-button>
      <el-button class="item" size="mini" @click="baseDraw('square3')" type="primary">正方形</el-button>
      
    </div>
    <div class="bottom-div">
      <el-button size="mini" @click="save()" type="primary">保存</el-button>
      <el-button size="mini" @click="clear()" type="primary">清除</el-button>
    </div>
  </div>
</template>

<script>
import PlotManage from "@/utils/cesiumBD/plot/PlotManage.js";
import { initPloys } from "./loadPloy.js";
let plotUti = undefined;
export default {
  mounted() {
    //this.addTile();
  },
  methods: {
    baseDraw(type) {
      if (!plotUti) {
        plotUti = new PlotManage({
          canEdit: true,
          billboard: {
            canEdit: true,
            style: {
              image: require("../../assets/plot_position.png"),
            }
          }
        });
      }
      plotUti.start(type);
    },
    addTile() {
      var tileset = new Cesium.Cesium3DTileset({
        url: "/staticdata/WCOSGB/1data/tileset.json",
      });
      viewer.scene.primitives.add(tileset);
      viewer.zoomTo(tileset, new Cesium.HeadingPitchRange(0, -Math.PI / 2, 0));
      //initPloys();
    },
    //坐标点旋转测试
    test() {
      var a = Cesium.Cartesian3.fromDegrees(111, 33, 100);

      var c = Cesium.Cartesian3.fromDegrees(111, 32, 100);

      let positions = [];
      positions.push(a);
      for (var i = 0; i <= 360; i++) {
        var b = this.getRotateCenterPoint(c, positions[i], 1);
        this.createPoint(b);
        positions.push(b);
      }

      this.createPoint(a, Cesium.Color.AQUA);
      var p = this.createPoint(c, Cesium.Color.RED);
      viewer.zoomTo(p);

      // for (var i = 0; i < positions.length - 1; i++) {
      //   var angle = this.getAngleCenterPointDir(c, positions[i], positions[i + 1]);
      //   let theta = angle * (180 / Math.PI);
      //   if (theta < 0) {
      //     theta = theta + 360;
      //   }
      //  console.log(theta);
    },
    getRotatePos(pointA, pointB, angle) {
      //然后使用Transforms类中的rotate方法进行旋转，将旋转后的向量加上点A的坐标，即可得到旋转后的坐标：
      var vector = Cesium.Cartesian3.subtract(pointB, pointA, new Cesium.Cartesian3());

      var rotatedVector = Cesium.Matrix3.multiplyByVector(
        Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(angle)),
        vector,
        new Cesium.Cartesian3()
      );
      var rotatedPoint = Cesium.Cartesian3.add(
        pointA,
        rotatedVector,
        new Cesium.Cartesian3()
      );

      return rotatedPoint;
    },
    getAngleCenterPointDir(center, pointA, pointB) {
      //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
      const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
      //求世界坐标到局部坐标的变换矩阵
      const worldToLocal_Matrix = Cesium.Matrix4.inverse(
        localToWorld_Matrix,
        new Cesium.Matrix4()
      );
      //a点在局部坐标的位置，其实就是局部坐标原点
      const localPosition_A = Cesium.Matrix4.multiplyByPoint(
        worldToLocal_Matrix,
        pointA,
        new Cesium.Cartesian3()
      );
      //B点在以A点为原点的局部的坐标位置
      const localPosition_B = Cesium.Matrix4.multiplyByPoint(
        worldToLocal_Matrix,
        pointB,
        new Cesium.Cartesian3()
      );

      //弧度
      const angle1 = Math.atan2(localPosition_A.x - 1, localPosition_A.y - 0);
      const angle2 = Math.atan2(localPosition_B.x - 1, localPosition_B.y - 0);

      const angle = angle2 - angle1;

      //角度
      //let theta = angle * (180 / Math.PI);
      // if (theta < 0) {
      //   theta = theta + 360;
      // }
      return angle;
    },
    createPoint(position, color) {
      var point = viewer.entities.add({
        position: position,
        point: {
          pixelSize: 10,
          color: color || Cesium.Color.YELLOW,
        },
      });
      return point;
    },

    /**
     * 计算两个点的方位角度
     */
    courseAngle(center, pointA, pointB) {
      //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
      const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
      //求世界坐标到局部坐标的变换矩阵
      const worldToLocal_Matrix = Cesium.Matrix4.inverse(
        localToWorld_Matrix,
        new Cesium.Matrix4()
      );
      //a点在局部坐标的位置，其实就是局部坐标原点
      const localPosition_A = Cesium.Matrix4.multiplyByPoint(
        worldToLocal_Matrix,
        pointA,
        new Cesium.Cartesian3()
      );
      //B点在以A点为原点的局部的坐标位置
      const localPosition_B = Cesium.Matrix4.multiplyByPoint(
        worldToLocal_Matrix,
        pointB,
        new Cesium.Cartesian3()
      );

      //弧度
      const angle1 = Math.atan2(localPosition_A.x - 1, localPosition_A.y - 0);
      const angle2 = Math.atan2(localPosition_B.x - 1, localPosition_B.y - 0);

      const angle = angle2 - angle1;

      //角度
      let theta = angle * (180 / Math.PI);
      // if (theta < 0) {
      //   theta = theta + 360;
      // }
      return theta;
    },

    getAngleCenterPoint(center, pointA, pointB) {
      var direction1 = Cesium.Cartesian3.subtract(
        center,
        pointA,
        new Cesium.Cartesian3()
      );

      var direction2 = Cesium.Cartesian3.subtract(
        center,
        pointB,
        new Cesium.Cartesian3()
      );

      var ray1 = new Cesium.Ray(center, direction1);
      var ray2 = new Cesium.Ray(center, direction2);
      var angle = Cesium.Cartesian3.angleBetween(ray1.direction, ray2.direction);
      var angle_deg = Cesium.Math.toDegrees(angle);

      return angle_deg;
    },
    getRotateCenterPoint(center, point1, angle) {
      // 计算center的地面法向量
      var chicB = Cesium.Cartographic.fromCartesian(center);
      chicB.height = 0;
      var dB = Cesium.Cartographic.toCartesian(chicB);

      var chicC = Cesium.Cartographic.fromCartesian(center);
      chicC.height = 10;
      var dC = Cesium.Cartographic.toCartesian(chicC);

      var normaB = Cesium.Cartesian3.normalize(
        Cesium.Cartesian3.subtract(dB, dC, new Cesium.Cartesian3()),
        new Cesium.Cartesian3()
      );

      // 构造基于center的法向量旋转angle度的矩阵
      var Q = Cesium.Quaternion.fromAxisAngle(normaB, Cesium.Math.toRadians(angle));
      var m3 = Cesium.Matrix3.fromQuaternion(Q);
      var m4 = Cesium.Matrix4.fromRotationTranslation(m3);

      // 计算point1点相对center点的坐标A1
      var A1 = Cesium.Cartesian3.subtract(point1, center, new Cesium.Cartesian3());

      //对A1应用旋转矩阵
      var p = Cesium.Matrix4.multiplyByPoint(m4, A1, new Cesium.Cartesian3());
      // 新点的坐标
      var pointNew = Cesium.Cartesian3.add(p, center, new Cesium.Cartesian3());

      return pointNew;
    },
    clear() {
      plotUti && plotUti.clear();
    },
    save() {
      plotUti && plotUti.save();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 16px 16px 16px 16px;
  display: grid;
  grid-gap: 16px;
  border: solid 1px #e4e7ed;
  overflow-y: auto;
  overflow-x: hidden;
  grid-template: repeat(2, 1fr) / repeat(2, 1fr);
}

.item {
  text-align: center;
  border: solid 1px #e4e7ed;
  width: auto;
  margin-left: 0px;
}

.bottom-div {
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
